<template>
  <RootContainer>
    <slot />
    <OrbVizLogo v-if="showLogo" class="bg-logo" />
  </RootContainer>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import RootContainer from '@/components/public/Layouts/RootContainer.vue'
import OrbVizLogo from '@/components/public/OrbVizLogo.vue'

const components = {
  RootContainer,
  OrbVizLogo,
}

const props = {
  showLogo: Boolean,
}

@Component({ components })
export default class RootTemplate extends Vue.extend({ props }) {}
</script>

<style scoped>
.bg-logo {
  position: absolute;
  z-index: 2;
  bottom: 0;
  right: 0;
  margin: 0 1rem 1rem 0;
  opacity: 0.85;
}
</style>
